import { render } from "./ServivesSidebar.vue?vue&type=template&id=7088825f&scoped=true"
import script from "./ServivesSidebar.vue?vue&type=script&lang=js"
export * from "./ServivesSidebar.vue?vue&type=script&lang=js"

import "./ServivesSidebar.vue?vue&type=style&index=0&id=7088825f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7088825f"]])

export default __exports__